import { createApp } from "vue";
import { createPinia } from "pinia";
import App from "./App.vue";
import router from "./router";
import "./assets/css/variables.css";
import "./assets/css/bootstrap-overrides.css";
import "./assets/css/nucleo-icons.css";
import "./assets/css/nucleo-svg.css";
import materialKit from "./material-kit";
import 'mdb-vue-ui-kit/css/mdb.min.css';
import VMdPreview from '@kangc/v-md-editor/lib/preview';
import vuepressTheme from '@kangc/v-md-editor/lib/theme/vuepress.js';
VMdPreview.use(vuepressTheme);
import '@kangc/v-md-editor/lib/style/base-editor.css';
import '@kangc/v-md-editor/lib/theme/style/vuepress.css';
import store from "./store"//全局变量管理
import "./assets/css/main-common.css"
import "./assets/css/variables.css"
import { createI18n } from 'vue-i18n';
import ZH from "./utils/lang/cn.js"
import EN from "./utils/lang/en.js"
import FR from "./utils/lang/fr.js"
import ES from "./utils/lang/es.js"
import DE from "./utils/lang/de.js"
import PL from "./utils/lang/pl.js"

// import vue3GoogleLogin from 'vue3-google-login'
import VueLazyLoad from 'vue3-lazyload'
import fr from "./utils/lang/fr.js";
import "./assets/css/global.css";

//国际化语言包
const messages = {
    zh: ZH,
    en: EN,
    fr: FR,
    es: ES,
    de: DE,
    pl: PL
};


function getQueryVariable(variable) {
    var query = window.location.search.substring(1);
    var vars = query.split("&");
    for (var i = 0; i < vars.length; i++) {
        var pair = vars[i].split("=");
        if (pair[0] == variable) {
            return pair[1];
        }
    }

    return (false);
}
let lang = getQueryVariable('lang')
if (!lang) {
    //en cn
    lang = localStorage.getItem('langSet') == null ? "en" : localStorage.getItem('langSet')
}
localStorage.setItem('langSet', lang)
const i18n = createI18n({
    legacy: false,
    globalInjection: true,
    locale: lang,
    messages
});
//国际包结束


const app = createApp(App);

app.use(createPinia());
app.use(router);
app.use(materialKit);
// app.use(ElementPlus);
app.use(VMdPreview);
app.use(store)
app.use(i18n);
app.use(VueLazyLoad, {
    loading: import('@/assets/img/load-image.png'),
}
);
app.mount("#app");
